export const HOME_SCREEN = 'HOME_SCREEN'
export const GAME_SCREEN = 'GAME_SCREEN'

export const PUBLIC_IMAGE_PATH = '/assets/icons'

export const EASY_LEVEL = 'EASY LEVEL'
export const MEDIUM_LEVEL = 'MEDIUM LEVEL'
export const DIFFICULTY_LEVEL = 'DIFFICULTY LEVEL'

export const GAME_LEVELS =  [EASY_LEVEL , MEDIUM_LEVEL, DIFFICULTY_LEVEL];
export const DEFAULT_INTERVAL_TIME  = 2;

export const PRIORITY_LEVEL_FOR_EASY = 1
export const PRIORITY_LEVEL_FOR_MEDIUM = 1.5
export const PRIORITY_LEVEL_FOR_DIFFICULTY = 2

export const DIFFICULTY_FACTOR_INCREASE = 0.01

export const GAME_OVER = 'GAME_OVER'
export const GAME_STARTED = 'GAME_STARTED'